import React, { useEffect, useState } from "react";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import "./style.css";
import loadConfig from "../../../Services/apiService";
import {
  GetAC_AcknowledgementById,
  SetAcknowledgement,
} from "../../../Redux/Reducers/Acknowledgement";
import { useDispatch, useSelector } from "react-redux";
import UpdateAcknowledgement from "../../../Services/Acknowledgement/UpdateAcknowledgement";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../Services/Account/EncryptionParams";

function PledgeAndAcknowledgement() {
  const AppGuid = useParams()
  //   const [pledgeText, setPledgeText] = useState("");
  const [jsonFile, setJsonFile] = useState();
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      Acknowledgement: state.Acknowledgement.Acknowledgement,
      loadingAcknowledgement: state.loadingAcknowledgement,
      ActiveRound: state.ApplicationInformation.ActiveRound,

    };
  });
  const [checked, setchecked] = useState({ ...state.Acknowledgement });
  const dataJson = async () => {
    let jsonData = await loadConfig();
    setJsonFile(jsonData);
  };
  useEffect(() => {
    dataJson();
  }, []);

  useEffect(() => {
    dispatch(
      GetAC_AcknowledgementById(
        localStorage.getItem("aI_ApplicationInformationId")||decryptToken(AppGuid.AppGuid) 
      )
    );
  }, []);

  //[,]
  //to asssigin data after loading end
  useEffect(() => {
    if (state.loadingAcknowledgement && state.Acknowledgement) {
      setchecked({ ...state.Acknowledgement });
    }
  }, [state.loadingAcknowledgement, state.Acknowledgement]);

  useEffect(() => {
    dispatch(SetAcknowledgement({ ...checked }));
  }, [checked]);
  const shouldDisableFields =!(
   //[,]
// مابقدر يعدل اذا ماكانت الدورة فعالة او managerالحالة قيد المراجة او الدخول من ال
state.ActiveRound ==
      state.ApplicationInformation?.aI_RoundYearId &&
    state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
    window.location.href.includes("manager") == false);
  return jsonFile && !state.loadingAcknowledgement ? (
    <>
      <SharedDiv
        showTitle={true}
        titleName="تعهد واقرار"
        child={[
          <div className="checkbox-container" key="checkbox">
            <label className="checkbox-label">
              <input
                type="checkbox"
                className="checkbox-input"
                checked={state.Acknowledgement?.acknowledgementStatus}
                onChange={(e) => {
                  setchecked({
                    ...checked,
                    acknowledgementStatus: e.target.checked,
                  });
                  UpdateAcknowledgement({
                    aC_AcknowledgementId:
                      state.Acknowledgement.aC_AcknowledgementId,
                    acknowledgementStatus: e.target.checked,
                    aI_ApplicationInformationId:
                      state.Acknowledgement.aI_ApplicationInformationId,
                  });
                }}
                disabled={shouldDisableFields}
              />
              {jsonFile.pledgeText}
            </label>
          </div>,
        ]}
      />
    </>
  ) : (
    ""
  );
}

export default PledgeAndAcknowledgement;
